import { html } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

export const Template = ({
    endpoint,
    locale,
    homeLinkUrl,
    homeLinkText,
    logoLinkUrl,
    profileLinkText,
    _slot,
}) => html`
    <ux-iws-sf-page-header
        endpoint=${ifDefined(endpoint)}
        locale=${ifDefined(locale)}
        home-link-url=${ifDefined(homeLinkUrl)}
        home-link-text=${ifDefined(homeLinkText)}
        logo-link-url=${ifDefined(logoLinkUrl)}
        profile-link-text=${ifDefined(profileLinkText)}
    >
        ${unsafeHTML(_slot)}
    </ux-iws-sf-page-header>
`;
